import { createSelector } from 'reselect';

export const campaignsGroupStateSelector = state => state.campaignsGroupReducer;

export const campaignsGroupMapSelector = createSelector(
    campaignsGroupStateSelector,
    campaignsGroupState => campaignsGroupState.campaignsGroups
);
